<template>
  <button v-if="!link" :type="type" :class="mode">
    <slot></slot>
  </button>
  <router-link v-else :to="to" :class="mode">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: "BaseButton",
  //props:['type', 'mode'],
  props: {
    type: {
      type: String,
      required: false,
      default: 'button',
    },
    mode: {
      type: String,
      required: false,
      default: '',
    },
    link: {
      type: Boolean,
      required: false,
      default: false,
    },
    to: {
      type: String,
      required: false,
      default: "'/'",
    }
  }
}
</script>